import React, { useState } from 'react'
import { TableDataPropsType } from '../../features/brandDashboard/brandDashboardType';
import Button, { ButtonProps } from '@mui/material/Button';
import { createSvgIcon } from '@mui/material/utils';
import {
    DataGrid,
    GridCsvExportOptions,
    GridCsvGetRowsToExportParams,
    gridPaginatedVisibleSortedGridRowIdsSelector,
    gridSortedRowIdsSelector,
    GridToolbarContainer,
    gridExpandedSortedRowIdsSelector,
    useGridApiContext,
    GridRowSpacingParams,
} from '@mui/x-data-grid';
import { makeStyles } from "@material-ui/core";

export default function TableData(props: TableDataPropsType) {
    const { data, columns } = props;
    const [searchText, setSearchText] = useState('');

    const getRowsFromCurrentPage = ({ apiRef }: GridCsvGetRowsToExportParams) =>
        gridPaginatedVisibleSortedGridRowIdsSelector(apiRef);

    const getUnfilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
        gridSortedRowIdsSelector(apiRef);

    const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
        gridExpandedSortedRowIdsSelector(apiRef);

    const ExportIcon = createSvgIcon(
        <path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z" />,
        'SaveAlt',
    );

    const getRowSpacing = (params: GridRowSpacingParams) => ({
        top: params.isFirstVisible ? 0 : 5,
        bottom: params.isLastVisible ? 0 : 5
    });

    function CustomToolbar() {
        const apiRef = useGridApiContext();

        const handleExport = (options: GridCsvExportOptions) =>
            apiRef.current.exportDataAsCsv(options);

        const buttonBaseProps: ButtonProps = {
            color: 'primary',
            size: 'small',
            startIcon: <ExportIcon />,
        };

        return (
            <GridToolbarContainer className='excel-filter-wrapper'>
                <Button
                    {...buttonBaseProps}
                    onClick={() => handleExport({ getRowsToExport: getRowsFromCurrentPage })}
                >
                    Current page rows
                </Button>
                <Button
                    {...buttonBaseProps}
                    onClick={() => handleExport({ getRowsToExport: getFilteredRows })}
                >
                    Filtered rows
                </Button>
                <Button
                    {...buttonBaseProps}
                    onClick={() => handleExport({ getRowsToExport: getUnfilteredRows })}
                >
                    Unfiltered rows
                </Button>
            </GridToolbarContainer>
        );
    }


    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some(
            (value) =>
                typeof value === 'string' && value.toLowerCase().includes(searchText.toLowerCase())
        )
    );

    const useStyle = makeStyles({
        root: {
            "& .wrapHeader .MuiDataGrid-colCellTitle": {
                overflow: "visible",
                lineHeight: "normal",
                whiteSpace: "normal",
                wordWrap: 'break-word',
                marginTop: 3,
            },
            "& .MuiDataGrid-row": {
                border: "none",
                borderRadius: "5px",
                backgroundColor: "white",
                marginTop: 2,
                marginBottom: 2,
                marginLeft: 5,
                marginRight: 5,
            },
            '&>.MuiDataGrid-main': {
                '&>.MuiDataGrid-columnHeaders': {
                    borderBottom: '3px solid #dee2e6',
                    verticalAlign: 'middle',
                    marginLeft: 5,
                    marginRight: 5,
                },

                '& div div div div >.MuiDataGrid-cell': {
                    borderBottom: '1px solid #dee2e6',
                    verticalAlign: 'middle',
                },
            }
        },

        headerCell: {
            backgroundColor: '#def2ff',
            color: 'white',
            fontWeight: 'bold',
        },
        row: {
            '&: td, &: th': {
                border: 0,
            },
        },
    });

    const classes = useStyle();

    const filterModel = {
        items: [
            { id: 1, field: 'brand', operator: 'contains', value: searchText },
            { id: 2, field: 'totalSku', operator: 'contains', value: searchText },
            { id: 3, field: 'totalImage', operator: 'contains', value: searchText },
            { id: 4, field: 'sohSku', operator: 'contains', value: searchText },
            { id: 5, field: 'sohImg', operator: 'contains', value: searchText },
            { id: 6, field: 'imageTagPerc', operator: 'contains', value: searchText },
            { id: 7, field: 'sohPerc', operator: 'contains', value: searchText },
        ],

    };

    return (
        <div className='table-data-wrapper'>
            <div className='search-box-wrapper'>
                <label className="search-box-label">Search: </label>
                <input className='search-box'
                    type="text"
                    placeholder="Search"
                    value={searchText}
                    onChange={handleSearch}
                />
            </div>

            <DataGrid
                getRowId={(row) => row.brand}
                sx={{
                    "& .MuiDataGrid-columnHeaderTitle": {
                        whiteSpace: "normal",
                        lineHeight: "normal",
                        fontWeight: 'bold',
                    },
                    "& .MuiDataGrid-columnHeader": {
                        height: "unset !important",
                    },
                    borderTop: 0,
                    borderLeft: 0,
                    borderRight: 0,
                    verticalAlign:'middle',
                }}
                classes={{ row: classes.row }}
                className={classes.root}
                rows={filteredData}
                columns={columns}
                disableColumnMenu={true}
                slots={{ toolbar: CustomToolbar }}
                filterModel={filterModel}
                autoHeight
                getRowSpacing={getRowSpacing}
                rowHeight={33}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 10,
                        },
                    },
                }}
            />
        </div>
    );
}
